// import { Message } from 'element-ui'
import { profileApi } from '@/api/common/user'
import { loginThirdParty, login, loginV2, logout } from '@/api/common/user'
import { getUrlKey, isInIframe, getUrl } from '@/utils'

import { getToken, setToken, removeToken, clearRememberMe, loginFn } from '@/utils/auth'
import { getEnvObj } from '@/utils/env'
// import { profileApi } from '@/api/common/public'
import { resetRouter } from '@/router'
import { isOS } from '@/utils/constant'
import { $track } from '../../utils/reporter'
const state = {
  token: getToken(), // 获取cookies中的token
  roles: [], // 角色权限
  userInfo: loginFn.getUserInfo(), // 用户登录后，返回的登录信息
  accountInfo: {}, // 账户信息
  isAgreeFirst: false,
  isAgreeSecond: false,
  isAgreeThird: false,
  isRepeat: false, // 账号重复
  twoFactorAuthLoading: false, // 2FA登录中标识
  twoFactorAuth: {
    showDialog: false,
    scene: '', // 认证类型，如：password | validateCode | smsCode
    twoFactorTicket: '', // 2FA验证码
    userInfo: {},
    resolve: null,
    reject: null,
    phoneCode: '',
    phoneNumber: '',
    pwdEmpty: false,
    email: ''
  },
  preloadingForm: {
    phoneCode: '',
    phoneNumber: ''
  }
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_ACCOUNT_INFO: (state, accountInfo) => {
    state.accountInfo = accountInfo
  },
  SET_AGREE_FIRST: (state, payload) => {
    state.isAgreeFirst = payload
  },
  SET_AGREE_SECOND: (state, payload) => {
    state.isAgreeSecond = payload
  },
  SET_AGREE_THIRD: (state, payload) => {
    state.isAgreeThird = payload
  },
  SET_IS_REPEAT: (state, payload) => {
    state.isRepeat = payload
  },
  SET_TWO_FACTOR_AUTH: (state, payload) => {
    state.twoFactorAuth = payload
  },
  SET_TWO_FACTOR_AUTH_LOADING: (state, payload) => {
    state.twoFactorAuthLoading = payload
  },
  SET_PRELOADING: (state, payload) => {
    state.preloadingForm = payload
  }
}

const actions = {
  // ?登录接口，通过登录页面登录
  THIRD_PARTY_LOGIN({ rootState, commit, dispatch }, userInfo) {
    const params = Object.assign({}, userInfo.params)
    commit('SET_TWO_FACTOR_AUTH_LOADING', true)
    return new Promise((resolve, reject) => {
      const initHeaders = {
        'ver': 'V3',
        'sysCode': getUrlKey('sysCode') || 'ICAS'
      }
      const headers = userInfo.headers || initHeaders
      // const loginAPI = userInfo.apiName === 'tencent' ? loginV2 : login
      loginThirdParty(params, headers).then(res => {
        const data = res.data
        console.log('%c Line:62 🥛 data', 'color:#b03734', JSON.stringify(data))
        const { twoFactorTicket, scene, phoneCode, phoneNumber, pwdEmpty, email } = res.data
        if (twoFactorTicket) {
          commit('SET_TWO_FACTOR_AUTH', {
            showDialog: true,
            scene,
            twoFactorTicket,
            userInfo,
            resolve,
            reject,
            phoneCode,
            phoneNumber,
            pwdEmpty,
            email
          })
          commit('SET_TWO_FACTOR_AUTH_LOADING', false)
          return
        }
        if (rootState.user.twoFactorAuth.twoFactorAuth) {
          $track({ sceneType: 'Login', eventType: 'two_factor_auth_success' })
        }

        // 营销通知
        commit('site/SET_MESSAGE_NOTICE_DATA', {
          show: true,
          data,
          cb: () => {
            const obj = getEnvObj()
            // const scopeName = data.scopeName // scopeName值是CN，说明登录的账号属于CN域，若值是SG,说明登录的账号是SG域
            const siteEnv = obj.SITE
            const site = siteEnv[obj.CURRENT_SITE]
            console.log('登录获取token - 多域', site)
            console.log('登录获取token - 多域', obj.CURRENT_SITE)
            // const currentSite = obj.CURRENT_SITE
            console.log('登录获取token - 多域', site)
            if (data.isNeedJumpOldPage) { // 跳转手机号出现重复了
              commit('SET_IS_REPEAT', true)
              reject(res)
            } else {
              // if (scopeName !== currentSite && res.code === '0') { // 不属于同一个域名
              //   console.log('登录的账号不属于同一个域', site)
              //   const lang = rootState.site.language
              //   const sysCode = getUrlKey('sysCode')
              //   const sysCodeUrl = sysCode ? `&sysCode=${sysCode}` : ''
              //   const siteCountryCode = rootState.site.siteConfig.country
              //   const countryCodeUrl = siteCountryCode ? `&siteCountryCode=${siteCountryCode}` : ''
              //   console.log('rootState - lang', rootState.site.language)
              //   // os域直接跳，不需要切换当前域名
              //   if (isOS()) {
              //     window.location.href = '/#/logining?token=' + res.data.token + '&lang=' + lang + sysCodeUrl + countryCodeUrl
              //   } else {
              //     window.location.href = (site ?? '') + '/#/logining?token=' + res.data.token + '&lang=' + lang + sysCodeUrl + countryCodeUrl
              //   }
              // } else { // 属于同一个域名，登录成功直接进入账号安全页面
              const lang = rootState.site.language
              let sysCode = getUrlKey('sysCode')
              const from = getUrlKey('from')
              const sysCodeUrl = sysCode ? `&sysCode=${sysCode}` : ''
              const siteCountryCode = rootState.site.siteConfig.country
              const countryCodeUrl = siteCountryCode ? `&siteCountryCode=${siteCountryCode}` : ''
              console.log('rootState - lang', rootState.site.language)

              let redirectUrlTmp = ''
              // 如果不在iframe走重定向 在iframe
              if (!isInIframe()) {
                if (from) {
                  redirectUrlTmp = from
                }
                // 如果没有设置重定向页面那就直接跳转到设置列表页
                if (!redirectUrlTmp) {
                  if (isOS()) {
                    redirectUrlTmp = encodeURIComponent(location.origin + '/#/logining?lang=' + lang + sysCodeUrl + countryCodeUrl)
                  } else {
                    redirectUrlTmp = encodeURIComponent((site ?? '') + '/#/logining?lang=' + lang + sysCodeUrl + countryCodeUrl)
                  }
                  // redirectUrlTmp = encodeURIComponent(`${location.origin}/#/settingListView`)
                }
                // let sysCode = this.sysCode
                if (!sysCode) {
                  sysCode = 'IBU-ICAS-CORE'
                }
                const siteCountryCode = rootState.site.siteConfig.country ?? getUrlKey('siteCountryCode') // url上源系统编码
                // const gjUTM = trackGetUTM();
                const url = `${getUrl('/icas/auth/sso/login')}?siteCountryCode=${siteCountryCode}&ticket=${res.data.ticket}&sysCode=${sysCode}&lang=${
                  lang
                }&from=${redirectUrlTmp}`
                console.log('登录的账号属于同一个域', url)
                location.href = url
              } else {
                const origin = '*'
                const url = 'https://ibu-icas.sf-express.com/'
                // postmessage告诉iframe 父容器数据格式是 {"success": "0", data: {}}
                window.parent.postMessage(
                  {
                    success: '0',
                    api: 'login',
                    data: { token: res.data.token, ticket: res.data.ticket, sysCode: this.sysCode },
                  },
                  'https://ibu-icas.sf-express.com/'.replace(url, origin)
                )
              }

              // console.log('登录的账号属于同一个域', site)
              // data.loginName = data.username
              // data.loginNameSensitization = data.usernameSensitization
              // delete data.username
              // delete data.usernameSensitization
              // loginFn.setUserInfo(data)
              // commit('SET_TOKEN', data.token)
              // setToken(data.token, 'token')
              // commit('SET_USER_INFO', data)
              // resolve(res)
              // }
            }
          }
        }, { root: true })
      }).catch(error => {
        commit('SET_TWO_FACTOR_AUTH_LOADING', false)
        reject(error)
      })
    })
  },
  // 登录接口，通过登录页面登录
  LOGIN({ rootState, commit, dispatch }, userInfo) {
    const params = Object.assign({}, userInfo.params)
    return new Promise((resolve, reject) => {
      const initHeaders = {
        'ver': 'V3',
        'sysCode': getUrlKey('sysCode') || 'ICAS'
      }
      const headers = userInfo.headers || initHeaders
      const loginAPI = userInfo.apiName === 'tencent' ? loginV2 : login
      loginAPI(params, headers).then(res => {
        const data = res.data
        const obj = getEnvObj()
        const scopeName = data.scopeName // scopeName值是CN，说明登录的账号属于CN域，若值是SG,说明登录的账号是SG域
        const siteEnv = obj.SITE
        const site = siteEnv[scopeName]
        const currentSite = obj.CURRENT_SITE
        console.log('登录获取token - 多域', site)
        if (data.isNeedJumpOldPage) { // 跳转手机号出现重复了
          commit('SET_IS_REPEAT', true)
          reject(res)
        } else {
          if (scopeName !== currentSite && res.code === '0') { // 不属于同一个域名
            console.log('登录的账号不属于同一个域', site)
            const lang = rootState.site.language
            const sysCode = getUrlKey('sysCode')
            const sysCodeUrl = sysCode ? `&sysCode=${sysCode}` : ''
            const siteCountryCode = rootState.site.siteConfig.country
            const countryCodeUrl = siteCountryCode ? `&siteCountryCode=${siteCountryCode}` : ''
            console.log('rootState - lang', rootState.site.language)
            // os域直接跳，不需要切换当前域名
            if (isOS()) {
              window.location.href = '/#/logining?token=' + res.data.token + '&lang=' + lang + sysCodeUrl + countryCodeUrl
            } else {
              window.location.href = (site ?? '') + '/#/logining?token=' + res.data.token + '&lang=' + lang + sysCodeUrl + countryCodeUrl
            }
          } else { // 属于同一个域名，登录成功直接进入账号安全页面
            console.log('登录的账号属于同一个域', site)
            data.loginName = data.username
            data.loginNameSensitization = data.usernameSensitization
            delete data.username
            delete data.usernameSensitization
            loginFn.setUserInfo(data)
            commit('SET_TOKEN', data.token)
            setToken(data.token, 'token')
            commit('SET_USER_INFO', data)
            resolve(res)
          }
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户登录信息
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      // 从cookie中取userInfo
      const userInfo = loginFn.getUserInfo()
      // console.log('replaceToken验证')
      // debugger
      profileApi().then(async res => {
        const newData = res.data
        // console.log('replaceToken验证')
        // const obj = getEnvObj()
        // const scopeName = data.scopeName // scopeName值是CN，说明登录的账号属于CN域，若值是SG,说明登录的账号是SG域
        // const siteEnv = obj.SITE
        // const site = siteEnv[obj.CURRENT_SITE]
        // const sysCode = getUrlKey('sysCode')
        // const sysCodeUrl = sysCode ? `&sysCode=${sysCode}` : ''
        // const siteCountryCode = getUrlKey('siteCountryCode')
        // const countryCodeUrl = siteCountryCode ? `&siteCountryCode=${siteCountryCode}` : ''
        // const redirectUrl = getUrlKey('from')
        // console.log("replaceToken验证", newData['scopeName'], site, redirectUrl)

        if (newData) {
          for (const key in newData) {
            userInfo[key] = newData[key]
          }
        }
        userInfo.country = userInfo.country || ''
        loginFn.setUserInfo(userInfo)
        userInfo.roles = ['user']
        commit('SET_ROLES', userInfo.roles) // 角色权限管理
        commit('SET_TOKEN', userInfo.token) // 更新state里的token
        setToken(userInfo.token, 'token') // cookies中设置token
        commit('SET_USER_INFO', userInfo) // 获取登录用户相关信息（登录账号的脱敏字段）
        commit('SET_ACCOUNT_INFO', newData) // 用于ICAS自有账号信息 - 账号安全界面
        resolve(userInfo)
      }).catch(error => {
        console.log(error)
      })
    })
  },

  // 退出登录
  logout({ commit, dispatch, state }) {
    return new Promise((resolve, reject) => {
      logout().then((res) => {
        dispatch('resetToken')
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 清除cookie,清除缓存
  resetToken({ commit }) {
    return new Promise(resolve => {
      loginFn.removeUserInfo() // 清除cookie的userInfo
      sessionStorage.clear() // 清除所有sessionStorage缓存
      commit('SET_TOKEN', '') // 重置state里边的token
      commit('SET_ROLES', []) // 重置state里边的角色权限
      commit('SET_ACCOUNT_INFO', {}) // 账户信息
      commit('SET_USER_INFO', {}) // 登录信息
      // commit('app/SET_SYSTEM_SOURCE', '', { root: true }) // 置空system_source
      removeToken() // 清除cookie里的token
      resetRouter() //  重置路由
      clearRememberMe() // 清除cookie里的rememberMe
      removeToken('sidebarStatus') // 清除cookie里的sidebarStatus
      window.iuop = {}
      window.checkTokenError = null
      resolve()
    })
  },

  // 获取账户信息 - 用于SFBUY跳转拿到账号信息,用于SFBUY有几种身份认证的方式
  accountInfoAction({ commit }) {
    return new Promise((resolve, reject) => {
      profileApi().then((res) => {
        const data = res.data
        commit('SET_ACCOUNT_INFO', data)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}

